export default {
	accountNumber: 'Account Number',
	add: 'Add',
	addEmployees: 'Add Employees',
	address: 'Address',
	all: 'All',
	back: 'Back',
	bankAccount: 'Bank Account',
	bankName: 'Bank Name',
	cancel: 'Cancel',
	capitalBack: 'BACK',
	checking: 'Checking',
	city: 'City',
	close: 'Close',
	companyName: 'Company Name',
	confirm: 'Confirm',
	continue: 'Continue',
	corporation: 'Corporation',
	country: 'Country',
	creditCard: 'Credit Card',
	delete: 'Delete',
	dismiss: 'Dismiss',
	done: 'Done',
	edit: 'Edit',
	edit_profile: 'Edit Profile',
	emailAddress: 'Email Address',
	error: 'There was error. Please try again',
	firstName: 'First Name',
	goBack: 'Go Back',
	import: 'Import',
	important: 'Important',
	lastName: 'Last Name',
	less: 'Less',
	more: 'More',
	nationalID: 'National ID',
	next: 'Next',
	no: 'No',
	none: 'None',
	note: 'Note',
	notice: 'Notice',
	notifications: 'Notifications',
	ok: 'OK',
	partnership: 'Partnership',
	paymentMethod: 'Payment Method',
	phoneNumber: 'Phone Number',
	postalCode: 'Postal Code',
	reminder: 'Reminder',
	save: 'Save',
	saveAndContinue: 'SAVE AND CONTINUE',
	savings: 'Savings',
	select: 'Select',
	skills: 'Skills',
	skip: 'SKIP',
	state: 'State',
	street: 'Street',
	upload: 'UPLOAD',
	viewAll: 'View All',
	yes: 'Yes',
	zip: 'Zip'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/global.js